import React, { useState, useEffect } from "react";
import "../../components/State/State.css";
import axios from "axios";

const State = ({
  tokenStorage,
  openProfile,
  setOpenProfile,
  selectedStateId,
}) => {
  const [countryResponse, setCountryResponse] = useState([]);
  
  const baseAPI = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    if (storedToken) {
      axios
        .get(
          `${baseAPI}adminget/GETState?stateID=` +
            selectedStateId +
            `&countryID=0`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
         
          setFirstItem(response.data.data[0]);
        
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  const [firstItem, setFirstItem] = useState({

    state_id: selectedStateId,
    country_id: "",
    stateName: "",
    countryname: "",

  });
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFirstItem((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFirstItem({
      state_id: selectedStateId,
    });
   
   
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
  
      const response = await axios.post(
        `${baseAPI}adminpost/AddState`,
        {
          id: firstItem.state_id,
          name: firstItem.stateName,
          country_id: firstItem.country_id,
        }, // Send updated postData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      // Optionally, reset the form
      setFirstItem({
        stateName: "",
        name: "",
        countryname: "",
      });
      tokenStorage();
      setOpenProfile(!openProfile);
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };
  // --------------------------country------------------------
  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GETCountry?countryID=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
         
          setCountryResponse(response.data.data);
         
        })
        .catch((error) => {
          console.error("Error fetching user detail:", error);
        });
    }
  }, []);

  return (
    <div className="container-fluid">
      <br />

      <div className="stateDetail">
        <form className="state-form">
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Country Name*</td>
              <td>State Name*</td>
            </tr>

            <tr>
              <td>
                <select
                  className="dropdown-state"
                  name="country_id"
                  value={firstItem.country_id}
                  onChange={handleChange}
                >
                  <option className="dropdown-state" value="">
                    Select your option
                  </option>
                  {countryResponse.map((item) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </select>
              </td>
              <td>
                <input
                  type="text"
                  name="stateName"
                  value={firstItem.stateName}
                  placeholder="Enter Please"
                  onChange={handleChange}
                />
              </td>
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addState-button">
            <button
              type="submit"
              onClick={handleSubmit}
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default State;
